import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiListResponse } from '@core/api/api.model';
import {
  IFeatureConfiguration,
  IFeatureConfigurationUpdate,
  ISportConfiguration,
} from './feature-configuration.model';

@Injectable({ providedIn: 'root' })
export class FeatureConfigurationApi {
  private readonly http = inject(HttpClient);

  getBySport(featureSlug: string): Observable<IFeatureConfiguration | null> {
    return this.http
      .get<ApiListResponse<IFeatureConfiguration>>(`${environment.api}features/configurations/`, {
        params: { sport: featureSlug },
      })
      .pipe(map((res) => res.results[0] ?? null));
  }

  /**
   * Every sport's feature configuration with its sport summary expanded inline — the basis
   * for a sport picker plus that sport's reference-system context in one call.
   */
  getSportConfigurations(): Observable<ApiListResponse<ISportConfiguration>> {
    return this.http.get<ApiListResponse<ISportConfiguration>>(
      `${environment.api}features/configurations/`,
      { params: { expand: 'feature', category_name: 'sports' } },
    );
  }

  update(
    id: number,
    body: IFeatureConfigurationUpdate,
  ): Observable<IFeatureConfiguration> {
    return this.http.put<IFeatureConfiguration>(
      `${environment.api}features/configurations/${id}/`,
      body,
    );
  }
}
